/**
 * Deterministic per-identity avatar helpers, shared by every avatar in the admin so they look
 * consistent. The hue is hashed on a STABLE key : pass the account id (Auth0 sub / local id) rather
 * than the display name, so two people who share a name (e.g. two "Alexis Naud" accounts) still get
 * distinct colours.
 */

const AVATAR_HUES = [
	"bg-sky-100 text-sky-700",
	"bg-emerald-100 text-emerald-700",
	"bg-violet-100 text-violet-700",
	"bg-amber-100 text-amber-700",
	"bg-rose-100 text-rose-700",
	"bg-teal-100 text-teal-700",
	"bg-indigo-100 text-indigo-700",
	"bg-fuchsia-100 text-fuchsia-700",
];

/** A soft background+text hue for an initials avatar, hashed on a stable key (prefer the account id). */
export const avatarColor = (key: string): string => {
	const s = key ?? "";
	let hash = 0;
	for (let i = 0; i < s.length; i += 1) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
	return AVATAR_HUES[hash % AVATAR_HUES.length];
};

/** Two-letter initials from a display name (splits on spaces, @, ., _, -). */
export const userInitials = (name: string): string => {
	const cleaned = (name || "").trim();
	if (!cleaned) return "??";
	const parts = cleaned.split(/[\s@._-]+/).filter(Boolean);
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
